/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Type_ReturnInputs */

const vi_customer_debt_type_return = /** @type {(inputs: Customer_Debt_Type_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trả hàng`)
};

/**

* @param {Customer_Debt_Type_ReturnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_type_return = /** @type {((inputs?: Customer_Debt_Type_ReturnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Type_ReturnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_type_return(inputs)
});